import React, { Component } from 'react';
import { Grid, GridColumn} from '@progress/kendo-react-grid';
import { Button } from '@progress/kendo-react-buttons';
import { DatePicker } from '@progress/kendo-react-dateinputs';
import { MultiSelect } from '@progress/kendo-react-dropdowns';
import { PanelBar, PanelBarItem } from '@progress/kendo-react-layout';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { DebounceInput } from 'react-debounce-input';
import CustomDatePickerPopUp from './components/CustomDatePickerPopUp';
import { filterBy, orderBy } from '@progress/kendo-data-query';
import moment from 'moment';
import 'moment-timezone';
import * as loggerService from "../../integration/LoggerService";
import {LOG_TYPES} from "../../integration/IntegrationEnums";
import { 
  getProjectResources, 
  getLeavesIntegrated,
  getAllocationPercentageHistory,
  updateAllocationPercentageHistory,
  allocationChangeNotification,
 } from '../../resourceManagement/ResourceService';
import { getBillingDiviDropDownIntegrated, getPracticeTypesIntegrated, getskillAreaIntegrated, getHolidaysIntegrated } from '../../integration/MasterDataService';
import { getRegions} from '../../masterData/region/RegionService';
import { getAllDesignations } from "../../masterData/designation/DesignationService";
import {  getcustomers } from "../../masterData/customer/CustomerService";
import { getResourceList, getAllocationList, getAllProjectsAndCrs, updateResourceRequest } from './ResourceUtilizationService';
import CustomCalendar from './CustomCalendar';
import UserRoleEnums from "./components/UserRoleEnums";
import UncontrolledTooltip from 'reactstrap/lib/UncontrolledTooltip';
import Loader from '../../integration/components/Loader';
import { getFormattedDate, isWeekend } from '../../integration/CommonUtils';
import {  getCostofAllocatedResource } from '../../masterData/costCard/CostCardService';
import SuccessImg from '../../ui/static/images/checked.svg';
import ErrorImg from '../../ui/static/images/cancel.svg';
import { saveAuditTrail } from '../../integration/auditTrail/AuditTrailService';

class DailyUtilization extends Component {

  isMount = false;

  constructor(props) {
    super(props);

    this.state = {
        loading: false,
        resources: [],
        resourcesAll: [],
        projectsAndCrs: [],
        projectsAndCrsAll: [],
        departmentData: [],
        departmentDataAll: [],
        practiceData: [],
        practiceDataAll: [],
        designations: [],
        designationsAll: [],
        projectRegions: [],
        projectRegionsAll: [],
        customers: [],
        customersAll: [],
        skillAreas: [],
        skillAreasAll: [],
        selectedResource: null,
        selectedProjectOrCr: null,
        selectedDepartment: null,
        selectedPractice: null,
        selectedDesignation: null,
        selectedProjectRegion: null,
        selectedCustomer: null,
        selectedSkillArea:null,
        startDate: new Date(),
        resourceList: [],
        allocationList: [],
        dailyTotalHours: [],
        dateColumnsArray: [],
        expandedPanels: new Set(),
        pmUserRole: false,
        isDisable: false,
        allocationHistoryMinDate: null,
        allocationHistoryMaxDate: null,
        allocationPercentageStartDate: null,
        allocationPercentageEndDate: null,
        changedllocationPercentage: null,
        allocationHistoryDataItem: null,
        allocationPercentageEffortDays: null,
        disableConfirmButton: true,
        showChangeAllocationDialog: false,
        showMessageDialog: false,
        dialogMessage: '',
        dialogTitle: '',
        isApprovedDuration: false,
        monthlyTotalHours: [],
    };
  }

  async componentDidMount() {
    this.isMount = true;
    this.props.onHeaderTitleChange('Daily Resource Utilization');
    await this.populateInitialData();
    await this.checkUserRole();
  }

  componentWillUnmount() {
    this.isMount = false;
  }

  populateInitialData = async () => {
    await this.setState({
        loading: true
    });
    await this.getAllActiveResources();
    await this.populateProjectsAndCRs();
    await this.populateDepartments();
    await this.populatePractices();
    await this.populateDesignations();
    await this.populateProjectRegions();
    await this.populateCustomers();
    await this.populateSkillAreas();
    await this.setState({
        loading: false
    });
  }

  checkUserRole = async () => {
    const userRoles = window.LOGGED_USER.roles;
    const pmUserRole = userRoles.some(obj => 
      obj.Rolename === UserRoleEnums.PM || 
      obj.Rolename === UserRoleEnums.PMO || 
      obj.Rolename === UserRoleEnums.FINANCE_MANAGER || 
      obj.Rolename === UserRoleEnums.RP || 
      obj.Rolename === UserRoleEnums.SYSTEM_ADMIN || 
      obj.Rolename === UserRoleEnums.DEPARTMENT_HEAD || 
      obj.Rolename === UserRoleEnums.PRACTICE_HEAD
    );

    const viewAllPermission = window.USER_PERMISSION.filter(obj => obj === 'DAILY_UTILI_ALL');
    const allAccess = (pmUserRole || viewAllPermission.length > 0) ? true : false;

    await this.setState({
      pmUserRole: allAccess
    });

    if (!allAccess) {
      const resource = this.state.resourcesAll.filter(val => val.Email.toUpperCase() == window.LOGGED_USER.userId.toUpperCase());
      await this.setState({
        isDisable: true,
        selectedResource: resource
      });
      this.submitSearch();
    }
  }

  onSaveAuditTrail = async() => {
    const auditTrail = {
        Action: 'Daily Resource Utilization viewed',
        RefType: 'Resource Utilization',
        RefId: window.LOGGED_USER.user,
        RefName: window.LOGGED_USER.displayName
    }
    await saveAuditTrail(auditTrail);
  }

  getAllActiveResources = async () => {
    await getProjectResources() 
      .then(async res => {
        await this.setState({
          resources: res.data,
          resourcesAll: res.data,
        });
      })
      .catch(error => {
        loggerService.writeLog(error, LOG_TYPES.ERROR);
      });
  };

  populateProjectsAndCRs = async() => {
    await getAllProjectsAndCrs()
      .then(res => {
        if (this.isMount) {
          this.setState({
            projectsAndCrs: res.data,
            projectsAndCrsAll: res.data,
          });
        }
      })
      .catch(error => {
        loggerService.writeLog(error, LOG_TYPES.ERROR);
      });
  };

  populateDepartments = async () => {
    await getBillingDiviDropDownIntegrated()
        .then(response => {
            this.setState({
                departmentData: response.data.filter(el => el.IsActive === true && el.SFCode !== null),
                departmentDataAll: response.data.filter(el => el.IsActive === true && el.SFCode !== null)
            });
        })
        .catch(error => {
            loggerService.writeLog(error, LOG_TYPES.ERROR);
        });
  };

  populatePractices = async() => {
    await getPracticeTypesIntegrated()
      .then(res => {
        if (this.isMount) {
          this.setState({
            practiceData: res.data,
            practiceDataAll: res.data,
          });
        }
      })
      .catch(error => {
        loggerService.writeLog(error, LOG_TYPES.ERROR);
      });
  };

  populateDesignations = async () => {
    await getAllDesignations()
      .then(res => {
        if (this.isMount) {
          this.setState({
            designations: res.data,
            designationsAll: res.data,
          });
        }
      })
      .catch(error => {
        loggerService.writeLog(error, LOG_TYPES.ERROR);
      });
  };

  populateProjectRegions = async () => {
    await getRegions()
      .then(res => {
        if (this.isMount) {
          this.setState({
            projectRegions: res.data,
            projectRegionsAll: res.data,
          });
        }
      })
      .catch(error => {
        loggerService.writeLog(error, LOG_TYPES.ERROR);
      });
  };

  populateCustomers = async () => {
    await getcustomers()
      .then(res => {
        if (this.isMount) {
          this.setState({
            customers: res.data,
            customersAll: res.data,
          });
        }
      })
      .catch(error => {
        loggerService.writeLog(error, LOG_TYPES.ERROR);
      });
  };

  populateSkillAreas = async () => {
    await getskillAreaIntegrated()
      .then(res => {
        const activeSkillAreas = res.data.filter(val => val.IsActive);
        if (this.isMount) {
          this.setState({
            skillAreas: activeSkillAreas,
            skillAreasAll: activeSkillAreas,
          });
        }
      })
      .catch(error => {
        loggerService.writeLog(error, LOG_TYPES.ERROR);
      });
  };


  submitSearch = async event => {
    if (event) {
      event.preventDefault();
    }

    if (this.isMount) {
      await this.setState({
        loading: true
      });
    }

    if (this.state.startDate) {

      const firstDateOfMonth = new Date(this.state.startDate).setDate(1);
      const value = moment(new Date(this.state.startDate));
      const lastDateOfMonth = value.endOf('month'); 

      let dateColumnsArray = [];
      let date = new Date(firstDateOfMonth);
      while (date < new Date(lastDateOfMonth)) {
        let formattedDate = moment(date).format('YYYY-MM-DD');
        dateColumnsArray.push(formattedDate);
        date = new Date(moment(date).add(1, 'days'));
      }
  
      const fields = {
          selectedResource: this.state.selectedResource && this.state.selectedResource.length > 0 ? this.state.selectedResource.map(value => value.id) : [],
          selectedProjectOrCr: this.state.selectedProjectOrCr && this.state.selectedProjectOrCr.length > 0 ? this.state.selectedProjectOrCr : [],
          selectedDepartment: this.state.selectedDepartment && this.state.selectedDepartment.length > 0 ? this.state.selectedDepartment.map(value => value.id) : [],
          selectedPractice: this.state.selectedPractice && this.state.selectedPractice.length > 0 ? this.state.selectedPractice.map(value => value.id) : [],
          selectedDesignation: this.state.selectedDesignation && this.state.selectedDesignation.length > 0 ? this.state.selectedDesignation.map(value => value.id) : [],
          selectedProjectRegion: this.state.selectedProjectRegion && this.state.selectedProjectRegion.length > 0 ? this.state.selectedProjectRegion.map(value => value.id) : [],
          selectedCustomer: this.state.selectedCustomer && this.state.selectedCustomer.length > 0 ? this.state.selectedCustomer.map(value => value.id) : [],
          selectedSkillArea: this.state.selectedSkillArea && this.state.selectedSkillArea.length > 0 ? this.state.selectedSkillArea.map(value => value.id) : [],
          StartDate: moment(new Date(firstDateOfMonth)).format('YYYY-MM-DD'),
          EndDate: moment(new Date(lastDateOfMonth)).format('YYYY-MM-DD')
      };        
  
      await getResourceList(fields)
        .then(async res => {
          if (this.isMount) {
              await this.setState({
                  resourceList: res.data,
                  dateColumnsArray: dateColumnsArray            
              });
          }
        })
        .catch(error => {
          loggerService.writeLog(error, LOG_TYPES.ERROR);
        });

      await this.onSaveAuditTrail();
      await this.expandedPanelQuery();
    }
  
    await this.setState({
      loading: false
    });
  };


  getAllocationList = async (userId) => {

    if (userId && this.state.startDate) {

      await this.setState({
        loading: true,
        expandedPanels: this.state.expandedPanels.add(userId)     
      });

      const firstDateOfMonth = new Date(this.state.startDate).setDate(1);
      const value = moment(new Date(this.state.startDate));
      const lastDateOfMonth = value.endOf('month'); 

      const fields = {
        selectedResource: [userId],
        selectedProjectRegion: this.state.selectedProjectRegion && this.state.selectedProjectRegion.length > 0 ? this.state.selectedProjectRegion.map(value => value.id) : [],
        selectedCustomer: this.state.selectedCustomer && this.state.selectedCustomer.length > 0 ? this.state.selectedCustomer.map(value => value.id) : [],
        selectedProjectOrCr: this.state.selectedProjectOrCr && this.state.selectedProjectOrCr.length > 0 ? this.state.selectedProjectOrCr : [],
        StartDate: moment(new Date(firstDateOfMonth)).format('YYYY-MM-DD'),
        EndDate: moment(new Date(lastDateOfMonth)).format('YYYY-MM-DD'),
        IsApprovedDuration: this.state.isApprovedDuration
    };        

    await getAllocationList(fields)
      .then(async res => {
        if (this.isMount) {
            const allocationList = res.data.AllocationList;
            const dailyTotalHours = res.data.DailyTotalHours;
            const monthTotalObj = {
              totalBillPlannedUtilization: res.data.TotalBillablePlannedUtilization,
              totalBillActualUtilization: res.data.TotalBillableActualUtilization,
              totalNonBillPlannedUtilization: res.data.TotalNonBillablePlannedUtilization,
              totalNonBillActualUtilization: res.data.TotalNonBillableActualUtilization
            }
            await this.setState({
              allocationList: {
                ...this.state.allocationList,
                [userId]: allocationList
              },
              dailyTotalHours: {
                ...this.state.dailyTotalHours,
                [userId]: dailyTotalHours
              },
              monthlyTotalHours: {
                ...this.state.monthlyTotalHours,
                [userId]: monthTotalObj
              }
            });
        }
      })
      .catch(error => {
        loggerService.writeLog(error, LOG_TYPES.ERROR);
      });
    }

    await this.setState({
      loading: false
    });
  }

  cancelSearch = async event => {
    await this.setState({
        selectedResource: null,
        selectedProjectOrCr: null,
        selectedDepartment: null,
        selectedPractice: null,
        selectedDesignation: null,
        selectedProjectRegion: null,
        selectedCustomer: null,
        selectedSkillArea: null,
        startDate: null,
        expandedPanels: new Set(),
    });
  }

  expandedPanelQuery = async () => {
    try {
      const expaned = Array.from(this.state.expandedPanels);
      if(expaned.length > 0){
        const expandedTasks = await expaned.map(async user => {
          await this.getAllocationList(user);
        });
        await Promise.all(expandedTasks);
        return Promise.resolve();
      }
    } catch (error) {
      loggerService.writeLog(error, LOG_TYPES.ERROR);
      return Promise.reject();
    }
  }

  handleStartDateChange = event => {
    let startDate = event.target.value;
    if (startDate) {
        const firstDateOfMonth = new Date(startDate).setDate(1);
        if (this.isMount) {
          this.setState({
            startDate: new Date(firstDateOfMonth),
          });
        }
    }
  };

  handleInputChange = event => {
    const valueObj = event.target.value;
    const field = event.target.name;
    if (this.isMount) {
      this.setState({
        [field]: valueObj
      });
    }
  };

  handleDurationChange = event => {
    const valueObj = event.target.value;
    const field = event.target.name;
    if (this.isMount) {
      if (valueObj === 'approvedduration') {
        this.setState({
          isApprovedDuration: true
        });
      } else {
        this.setState({
          isApprovedDuration: false
        });
      }
    }
  };

  filterData(filter, allData) {
    const data = allData.slice();
    return filterBy(data, filter);
  }

  filterResources = event => {
    if (this.isMount) {
      this.setState({
        resources: this.filterData(event.filter, this.state.resourcesAll)
      });
    }
  };

  filterProjectsAndCrs = event => {
    if (this.isMount) {
      this.setState({
        projectsAndCrs: this.filterData(event.filter, this.state.projectsAndCrsAll)
      });
    }
  };

  filterDepartments = event => {
    if (this.isMount) {
      this.setState({
        departmentData: this.filterData(event.filter, this.state.departmentDataAll)
      });
    }
  };

  filterPractices = event => {
    if (this.isMount) {
      this.setState({
        practiceData: this.filterData(event.filter, this.state.practiceDataAll)
      });
    }
  };

  filterDesignations = event => {
    if (this.isMount) {
      this.setState({
        designations: this.filterData(event.filter, this.state.designationsAll)
      });
    }
  };

  filterProjectRegions = event => {
    if (this.isMount) {
      this.setState({
        projectRegions: this.filterData(event.filter, this.state.projectRegionsAll)
      });
    }
  };

  filterCustomers = event => {
    if (this.isMount) {
      this.setState({
        customers: this.filterData(event.filter, this.state.customersAll)
      });
    }
  };

  filterSkillArea = event => {
    if (this.isMount) {
      this.setState({
        skillAreas: this.filterData(event.filter, this.state.skillAreasAll)
      });
    }
  };

  setTimeFormat = time => {
    if (time) {
      let durationParts = time.toString().split('.');
      let duration = durationParts[0];
      let durMinPart = this.roundUp(durationParts[1],1)
      .toString()
      .padStart(2, '0');

      if (typeof durationParts[1] !== 'undefined') {
        if(parseInt(durMinPart) === 60){
          duration = parseInt(duration) + 1;
          durMinPart = '00';
        }else{
          durMinPart = this.roundUp(durationParts[1],1).toString().padStart(2, '0');;
        }
        duration =
          parseInt(duration) +
          ':' + durMinPart
        return duration;
      } else {
        duration = parseInt(duration) + ':' + '00';
        return duration;
      }
    }
  };

  roundUp = (num, precision) => {
    num = parseFloat(`0.${num}`) * 60;
    num = num.toFixed(2) / 10;
    precision = Math.pow(10, precision);
    return (Math.ceil(num * precision) / precision) * 10;
  };

  setMonthlyTotal = (userId, field) => {
    if (this.state.monthlyTotalHours) {
      const userMonthTotals = this.state.monthlyTotalHours[userId];
      if(!userMonthTotals || !field){
        return "0.00%";
      }
      const totalVal = userMonthTotals[field];
      if (totalVal) {
        return totalVal;
      } else {
        return "0.00%";
      }
    }
    return "0.00%";
  }

  setDailyTotal = (userId, date, field, billability) => {
    if (this.state.dailyTotalHours) {
      const userTotals = this.state.dailyTotalHours[userId];

      if(!userTotals || !date || !field){
        return <td style={{ textAlign: 'center' }}>{0 + '%'}</td>;
      }
      const dateVal = userTotals[date];
  
      if (dateVal) {
        const uniqueId = field+date+userId+billability;
        if (billability == 'Billable') {
          return (
            <td style={{ textAlign: 'center' }}>
              <td id={uniqueId} style={{ textAlign: 'center' }}>
                {(field == 'Actual' ? Number(dateVal.BillableActualPercentage).toFixed(2) : Number(dateVal.BillablePlannedPercentage).toFixed(2)) + '%'}
              </td>
              <UncontrolledTooltip
                modifiers={{ preventOverflow: { boundariesElement: 'window' } }}
                target={uniqueId}
                placement="top"
                style={{ maxWidth: '300px' }}
              >
                <div className="text-left p-1">
                  <span>{(field == 'Actual' ? this.setTimeFormat(Number(dateVal.BillableActualHours).toFixed(2)) : this.setTimeFormat(Number(dateVal.BillablePlannedHours).toFixed(2))) + ' HH:MM'}</span>
                </div>
              </UncontrolledTooltip>
            </td>
          );
        } else {
          return (
            <td style={{ textAlign: 'center' }}>
              <td id={uniqueId} style={{ textAlign: 'center' }}>
                {(field == 'Actual' ? Number(dateVal.NonBillableActualPercentage).toFixed(2) : Number(dateVal.NonBillablePlannedPercentage).toFixed(2)) + '%'}
              </td>
              <UncontrolledTooltip
                modifiers={{ preventOverflow: { boundariesElement: 'window' } }}
                target={uniqueId}
                placement="top"
                style={{ maxWidth: '300px' }}
              >
                <div className="text-left p-1">
                  <span>{(field == 'Actual' ? this.setTimeFormat(Number(dateVal.NonBillableActualHours).toFixed(2)) : this.setTimeFormat(Number(dateVal.NonBillablePlannedHours).toFixed(2))) + ' HH:MM'}</span>
                </div>
              </UncontrolledTooltip>
            </td>
          );
        }
      }
    }
    return <td style={{ textAlign: 'center' }}>{0 + '%'}</td>;
  }

  customCell = (props, date, field) => {
    if (props.dataItem.Dates && props.dataItem.Dates.length > 0) {
      const dateVal = props.dataItem.Dates.find(value => value.Date == date);
      if (dateVal) {

        const cellColorStyle = {
          textAlign: 'center',
          backgroundColor: dateVal.isWeekend ? '#bab7b6' :
            dateVal.isLeave || dateVal.isHoliday ? '#b1e0fc' :
            dateVal.isNoAllocation ? '#f7f4c3' : ''
        };

        if (field == 'Actual') {
          cellColorStyle.borderLeft = '1px solid rgba(0, 0, 0, 1)'
        } 

        const checkDay = (dateVal.isWeekend || dateVal.isLeave || 
          dateVal.isHoliday || dateVal.isNoAllocation) ? true : false;
  
        const uniqueId = field+date+props.dataItem.UniqueId;
        return (
          <td style={cellColorStyle}>
            <td id={uniqueId}>
              {!checkDay ? (field == 'Actual' ? dateVal.ActualPercentage : dateVal.PlannedPercentage) + (props.dataItem.Type === 'NPT' && field == 'Planned' ? '' : '%') : ''}
            </td>
            {!checkDay && (
              <UncontrolledTooltip
                modifiers={{ preventOverflow: { boundariesElement: 'window' } }}
                target={uniqueId}
                placement="bottom"
                style={{ maxWidth: '300px' }}
              >
                {props.dataItem.Type !== 'NPT' ? (
                  <div className="text-left p-1">
                    <span>{(field == 'Actual' ? this.setTimeFormat(Number(dateVal.ActualHours).toFixed(2)) : this.setTimeFormat(Number(dateVal.PlannedHours).toFixed(2))) + ' HH:MM' + (dateVal.isHalfDay ? ' - Half Day' : '')}</span>
                  </div>
                ) : 
                  <div className="text-left p-1">
                    <span>{(field == 'Actual' ? this.setTimeFormat(Number(dateVal.ActualHours).toFixed(2)) + ' HH:MM' : dateVal.PlannedHours) + '' + (dateVal.isHalfDay ? ' - Half Day' : '')}</span>
                  </div>
                }
              </UncontrolledTooltip>
            )}
          </td>
        );
      } else {
        return <td style={{ textAlign: 'center' }}>{0 + '%'}</td>;
      }
    } else {
      return <td style={{ textAlign: 'center' }}>{0 + '%'}</td>;
    }
  }

  onClickEditAllocation = async (event, item) => {
    if (event) {
      event.preventDefault();
    }
    await this.toggleDialogAllocationPercentage(null, item);
  }

  toggleDialogAllocationPercentage = async (event, item) => {
    if (item) {
      const dataItem = item.ResourceRequest;
      await this.setState({
        allocationHistoryDataItem: dataItem,
        allocationPercentageStartDate: new Date(moment(new Date(dataItem.StartDate)).format('YYYY-MM-DD')) > new Date(moment(new Date()).format('YYYY-MM-DD')) ? new Date(dataItem.StartDate) : new Date(),
        allocationHistoryMaxDate: new Date(dataItem.EndDate),
        allocationHistoryMinDate: new Date(moment(new Date(dataItem.StartDate)).format('YYYY-MM-DD')) > new Date(moment(new Date()).format('YYYY-MM-DD')) ? new Date(dataItem.StartDate) : new Date(),
        disableConfirmButton: true,
      });  
    }
    await this.setState({
      showChangeAllocationDialog: !this.state.showChangeAllocationDialog,
    });  

    if (this.state.showChangeAllocationDialog == false) {
      await this.setState({
        allocationPercentageStartDate: null,
        allocationPercentageEndDate: null,
        changedllocationPercentage: null,
        allocationPercentageEffortDays: null,
        disableConfirmButton: true
      });
    }
  };

  handleAllocationPercentageChange = async event => {
    let value = event.target.value;
    if (value < 0) {
      value = 0;
    } else if (value > 100) {
      value = 100;
    }
    await this.setState({
      changedllocationPercentage: Number((Number(value)).toFixed(2))
    });
    if (this.state.allocationPercentageStartDate && this.state.allocationPercentageEndDate && this.state.changedllocationPercentage) {
      await this.checkNewAllocationEffort();
      await this.setState({
        disableConfirmButton: false
      });
    } else {
      await this.setState({
        disableConfirmButton: true
      });
    }
  };
  
  handleAllocationStartDateChange = async event => {
    let allocationPercentageStartDate = event.target.value;
    await this.setState({
      allocationPercentageStartDate: allocationPercentageStartDate
    });
    if (this.state.allocationPercentageStartDate && this.state.allocationPercentageEndDate && this.state.changedllocationPercentage) {
      await this.checkNewAllocationEffort();
      await this.setState({
        disableConfirmButton: false
      });
    } else {
      await this.setState({
        disableConfirmButton: true
      });
    }
  }

  handleAllocationEndDateChange = async event => {
    let allocationPercentageEndDate = event.target.value;
    await this.setState({
      allocationPercentageEndDate: allocationPercentageEndDate
    });
    if (this.state.allocationPercentageStartDate && this.state.allocationPercentageEndDate && this.state.changedllocationPercentage) {
      await this.checkNewAllocationEffort();
      await this.setState({
        disableConfirmButton: false
      });
    } else {
      await this.setState({
        disableConfirmButton: true
      });
    }
  }

  checkNewAllocationEffort = async () => {
    let selectedRequest = this.state.allocationHistoryDataItem;
    let resourceRequestId = null;
    let resourceRequestIdSub = null;
    if (selectedRequest.ResourceRequestId) {
      resourceRequestId = selectedRequest.ResourceRequestId;
      resourceRequestIdSub = selectedRequest.id;
      selectedRequest.Type = selectedRequest.ResourceRequest.Type;
      selectedRequest.Project = selectedRequest.ResourceRequest.Project;
      selectedRequest.ChangeRequest = selectedRequest.ResourceRequest.ChangeRequest;
    } else {
      resourceRequestId = selectedRequest.id;
    }
    const item = {
      ResourceRequestId: resourceRequestId,
      ResourceRequestSubLineId: resourceRequestIdSub,
      ResourceId: selectedRequest.ResourceId,
      StartDate: moment(this.state.allocationPercentageStartDate).format('YYYY-MM-DD'),
      EndDate: moment(this.state.allocationPercentageEndDate).format('YYYY-MM-DD'),
      AllocationPercentage: this.state.changedllocationPercentage
    }
    await this.calculateAllocationHistoryLineEffort(item, selectedRequest);
    await this.setState({
      allocationPercentageEffortDays: item.EffortDays,
    });
  }

  calculateAllocationHistoryLineEffort = async (historyLine, request) => {
    let totalWorkingDays = 0; // TO KEEP TRACK OF THE TOTAL WORKING DAYS
    let isHoliday = false;
    let isLeave = false;
    let isHalfDay = false;

    if (request && historyLine.StartDate && historyLine.AllocationPercentage > 0) {

      let startDate = new Date(historyLine.StartDate);
      let endDate = new Date(historyLine.EndDate);

      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(0, 0, 0, 0);

      let effort = 0;
      let resourceCountryId = null;
      if (request.OnsiteStatus === "Offshore") {
        resourceCountryId = request.dataValueResourceRegion ? request.dataValueResourceRegion.DefaultCountryId : null;
      } else if (request.OnsiteStatus === "Onsite") {
        resourceCountryId = request.Type === 'Project' ? request.Project.CountryId : request.ChangeRequest.CountryId;
      }
      let holidays = []; 
      holidays = await getHolidaysIntegrated(resourceCountryId, startDate.getFullYear()).then(res => {
        if (res && res.data) {
          return res.data;
        }
        return [];
      })
        .catch(error => {
          loggerService.writeLog(error, LOG_TYPES.ERROR);
        });

      if (!holidays) {
        holidays = [];
      }
      const leaveObj = {
        ResourceId: request.ResourceId, 
        StartDate: moment(historyLine.StartDate).format('YYYY-MM-DD'), 
        EndDate: moment(historyLine.EndDate).format('YYYY-MM-DD')
      }
      let resourceLeaves = await getLeavesIntegrated(leaveObj).then(res => {
        if (res && res.data) {
            return res.data;
        }
        return [];
      })
      .catch(error => {
          loggerService.writeLog(error, LOG_TYPES.ERROR);
      });
      let loop = new Date(startDate);
      while (loop <= endDate) {
        isHoliday = false;
        isLeave = false;
        isHalfDay = false;
        const dateStr = getFormattedDate(loop);
        if (holidays.indexOf(dateStr) > -1) {
          isHoliday = true;
        }

        if (resourceLeaves && resourceLeaves.length > 0) {
          let leaveDate = resourceLeaves.filter(
              leave => leave.LeaveDate === dateStr
          );
          if (leaveDate && leaveDate.length > 0) {
              for (const leave of leaveDate) {
                  if (leave.Duration === '8') {
                      isLeave = true;
                  } else {
                      isHalfDay = true;
                  }
              }
            }
        }

        if (!isHoliday && !isLeave && !isWeekend(loop)) {
          if (!isHalfDay) {
            totalWorkingDays = totalWorkingDays + 1;
          } else {
            totalWorkingDays = totalWorkingDays + 0.5;
          }
        }

        let newDate = loop.setDate(loop.getDate() + 1);
        loop = new Date(newDate);
      }

      effort = totalWorkingDays * (historyLine.AllocationPercentage / 100);
      historyLine.EffortDays = Number((effort).toFixed(2));
    }
  };

  updateAllocationPercentageHistory = async () => {
    await this.setState({
      disableConfirmButton: true
    });
    if (new Date(moment(this.state.allocationPercentageEndDate).format('YYYY-MM-DD')) < new Date(moment(this.state.allocationPercentageStartDate).format('YYYY-MM-DD'))) {
      this.setState({
        showSuccessImage: false,
        showErrorImage: true,
        disableConfirmButton: false
      });
      const message = 'The End Date cannot be earlier than the Start Date';
      const title = 'Error';
      this.toggleMessageDialog(message, title);
      return;
    }
    if (new Date(moment(this.state.allocationHistoryMinDate).format('YYYY-MM-DD')) > new Date(moment(this.state.allocationPercentageStartDate).format('YYYY-MM-DD'))) {
      this.setState({
        showSuccessImage: false,
        showErrorImage: true,
        disableConfirmButton: false
      });
      const message = 'The Start Date cannot be earlier than the Current Date';
      const title = 'Error';
      this.toggleMessageDialog(message, title);
      return;
    }
    if (new Date(moment(this.state.allocationHistoryMaxDate).format('YYYY-MM-DD')) < new Date(moment(this.state.allocationPercentageEndDate).format('YYYY-MM-DD')) ||
        new Date(moment(this.state.allocationHistoryMaxDate).format('YYYY-MM-DD')) < new Date(moment(this.state.allocationPercentageStartDate).format('YYYY-MM-DD'))) {
      this.setState({
        showSuccessImage: false,
        showErrorImage: true,
        disableConfirmButton: false
      });
      const message = 'The selected date range exceeds the Resource Allocation End Date';
      const title = 'Error';
      this.toggleMessageDialog(message, title);
      return;
    }
    await this.setState({
      loading: true
    });

    let lineAllocationHistoryList = [];
    let newlyAddedLines = [];
    let selectedRequest = this.state.allocationHistoryDataItem;
    const resourceRequestId = this.state.allocationHistoryDataItem && this.state.allocationHistoryDataItem.ResourceRequestId ? 
                              this.state.allocationHistoryDataItem.ResourceRequestId : this.state.allocationHistoryDataItem.id;
    const resourceRequestIdSub = this.state.allocationHistoryDataItem && this.state.allocationHistoryDataItem.ResourceRequestId ? 
                              this.state.allocationHistoryDataItem.id : null;
    const newStartDate = moment(this.state.allocationPercentageStartDate).format('YYYY-MM-DD');
    const newEndDate = moment(this.state.allocationPercentageEndDate).format('YYYY-MM-DD');
    const resourceId = this.state.allocationHistoryDataItem && this.state.allocationHistoryDataItem.ResourceId ? this.state.allocationHistoryDataItem.ResourceId : null;
    const resourceDetails = {
      resourceRequestId: resourceRequestId,
      resourceRequestIdSub: resourceRequestIdSub,
    };
    await getAllocationPercentageHistory(resourceDetails)
    .then(res => {
      lineAllocationHistoryList = res.data;
    }).catch(err => {
      loggerService.writeLog(err, LOG_TYPES.ERROR);
    });

    const obj = {
      ResourceRequestId: resourceRequestId,
      ResourceRequestSubLineId: resourceRequestIdSub,
      ResourceId: resourceId,
      StartDate: newStartDate,
      EndDate: newEndDate,
      AllocationPercentage: this.state.changedllocationPercentage
    }
    newlyAddedLines.push(obj);

    const validAlocationHistoryList = lineAllocationHistoryList.filter(record => {
      const newAllocStartDate = moment(newStartDate);
      const newAllocEndDate = moment(newEndDate);
      const recordStartDate = moment(record.StartDate);
      const recordEndDate = moment(record.EndDate);
      return newAllocStartDate.isBetween(recordStartDate, recordEndDate) || newAllocEndDate.isBetween(recordStartDate, recordEndDate) ||
      recordStartDate.isBetween(newAllocStartDate, newAllocEndDate) || newAllocStartDate.isSame(recordStartDate) || 
      newAllocEndDate.isSame(recordStartDate) || newAllocStartDate.isSame(recordEndDate)
    });

    for (const record of validAlocationHistoryList) {
      if (record.StartDate < newStartDate && record.EndDate > newEndDate) {
        const recordEndDate = record.EndDate;
        record.EndDate = moment(newStartDate).subtract(1, 'days').format('YYYY-MM-DD');
        const newObj = {
          ResourceRequestId: record.ResourceRequestId,
          ResourceRequestSubLineId: record.ResourceRequestSubLineId,
          ResourceId: resourceId,
          StartDate: moment(newEndDate).add(1, 'days').format('YYYY-MM-DD'),
          EndDate: recordEndDate,
          AllocationPercentage: record.AllocationPercentage
        }
        newlyAddedLines.push(newObj);
      } else if (record.StartDate >= newStartDate && record.EndDate <= newEndDate) {
        record.IsActive = false;
      } else if (record.StartDate <= newStartDate && record.EndDate <= newEndDate) {
        record.EndDate = moment(newStartDate).subtract(1, 'days').format('YYYY-MM-DD');
      } else if (record.StartDate >= newStartDate && record.EndDate > newEndDate) {
        record.StartDate = moment(newEndDate).add(1, 'days').format('YYYY-MM-DD');
      }
    }

    const allHistories = validAlocationHistoryList.concat(newlyAddedLines);
    if (selectedRequest.ResourceRequestId) {
      selectedRequest.Type = selectedRequest.ResourceRequest.Type;
      selectedRequest.Project = selectedRequest.ResourceRequest.Project;
      selectedRequest.ChangeRequest = selectedRequest.ResourceRequest.ChangeRequest;
    }

    for (const item of allHistories) {
      await this.calculateAllocationHistoryLineEffort(item, selectedRequest);
    }

    await updateAllocationPercentageHistory(allHistories)
    .then(async res => {
      await allocationChangeNotification(selectedRequest)
      .then(async res => {
      }).catch(err => {
        loggerService.writeLog(err, LOG_TYPES.ERROR);
      });

      await this.getCostForDesignation(selectedRequest);
      
      await updateResourceRequest(selectedRequest)
      .then(async res => {
        const resName = selectedRequest.Resource ? selectedRequest.Resource.Name : '';
        const opid = selectedRequest.Type === 'Project' ? selectedRequest.Project.UniqueId : selectedRequest.ChangeRequest.UniqueId;
        const auditTrail = {
          Action: 'Allocation percentage updated',
          RefType: 'Resource Utilization',
          RefId: selectedRequest.id,
          RefName: opid + ' - ' + resName
        }
        await saveAuditTrail(auditTrail)
        await this.submitSearch();
      }).catch(err => {
        loggerService.writeLog(err, LOG_TYPES.ERROR);
      });
  
      await this.setState({
        showChangeAllocationDialog: false,
        allocationPercentageStartDate: null,
        allocationPercentageEndDate: null,
        changedllocationPercentage: null,
        allocationPercentageEffortDays: null,
        disableConfirmButton: true
      });
      
    }).catch(err => {
      loggerService.writeLog(err, LOG_TYPES.ERROR);
    });
    await this.setState({
      loading: false
    });
  }

  getCostForDesignation = async dataItem => {
    let DirectCostInUSD = 0;
    let CostPerResourceInUSD = 0;
    let totalCostUSD = 0;
    let EffortDays = 0;

    const costItems = {
      resourceRequest: dataItem,
      mainLine: dataItem.ResourceRequestId ? false : true,
      projectId: dataItem.Type == 'ChangeRequest' ? dataItem.ChangeRequest.id : dataItem.Project.id,
      ofTypeProject: dataItem.Type == 'ChangeRequest' ? false : true,
    };
    await getCostofAllocatedResource(costItems).then(res => {
      totalCostUSD = res.data.TotalCost;
      DirectCostInUSD = res.data.DirectCost;
      CostPerResourceInUSD = res.data.CostPerResource;
      EffortDays = res.data.EffortDays;
    })
    .catch( async err => {
      totalCostUSD = 0;
      DirectCostInUSD = 0;
      CostPerResourceInUSD = 0;
      EffortDays = 0;
      loggerService.writeLog(err, LOG_TYPES.ERROR);

      const message = 'Cost card record not found for the selected designation and resource region';
      const title = 'Error';
      await this.setState({
        showSuccessImage: false,
        showErrorImage: true
      });

      await this.toggleMessageDialog(message, title);
    });

    dataItem.TotalCost = totalCostUSD;
    dataItem.Cost = totalCostUSD;
    dataItem.DirectCost = DirectCostInUSD;
    dataItem.CostPerResource = CostPerResourceInUSD;
    dataItem.EffortDays = EffortDays;

    // Revenue
    if (EffortDays && dataItem.RateValue) {
      dataItem.TotalRevenue = EffortDays * dataItem.RateValue;
      dataItem.Revenue = EffortDays * dataItem.RateValue;
    } else {
      dataItem.TotalRevenue = 0;
      dataItem.Revenue = 0;
    }

    // Cost to Revenue ratio
    if (totalCostUSD > 0 && dataItem.TotalRevenue > 0) {
      dataItem.CostToRevenueRatio = (totalCostUSD / dataItem.TotalRevenue).toFixed(2);
    } else {
      dataItem.CostToRevenueRatio = 0;
    }
  };

  toggleMessageDialog = (message, title) => {
    this.setState({
      showMessageDialog: !this.state.showMessageDialog,
      dialogMessage: message,
      dialogTitle: title
    });
  };
  
  render() {
    return (
      <div className="main-card">
        <div className="row">
          <div className="col-md-8">
            <div className="main-heading">Daily Resource Utilization</div>
          </div>
        </div>

        <form onSubmit={this.submitSearch}>
          <div className="row">

            <div className="col-md-3">
                <label className="">Resource:</label>
                <MultiSelect  
                    data={this.state.resources}
                    name="selectedResource"
                    textField="Name"
                    placeholder={'Please Select'}
                    onChange={this.handleInputChange}
                    value={this.state.selectedResource}
                    filterable={true}
                    onFilterChange={this.filterResources}
                    disabled={this.state.isDisable}
                />
            </div>

            {this.state.pmUserRole && (
              <div className="col-md-3">
                  <label className="">Project/CR Name:</label>
                  <MultiSelect  
                      data={this.state.projectsAndCrs}
                      name="selectedProjectOrCr"
                      textField="DisplayName"
                      placeholder={'Please Select'}
                      onChange={this.handleInputChange}
                      value={this.state.selectedProjectOrCr}
                      filterable={true}
                      onFilterChange={this.filterProjectsAndCrs}
                  />
              </div>
            )}

            {this.state.pmUserRole && (
              <div className="col-md-3">
                  <label className="">Department:</label>
                  <MultiSelect  
                      data={this.state.departmentData}
                      name="selectedDepartment"
                      textField="Name"
                      placeholder={'Please Select'}
                      onChange={this.handleInputChange}
                      value={this.state.selectedDepartment}
                      filterable={true}
                      onFilterChange={this.filterDepartments}
                  />
              </div>
            )}

            {this.state.pmUserRole && (
              <div className="col-md-3">
                  <label className="">Practice:</label>
                  <MultiSelect  
                      data={this.state.practiceData}
                      name="selectedPractice"
                      textField="Name"
                      placeholder={'Please Select'}
                      onChange={this.handleInputChange}
                      value={this.state.selectedPractice}
                      filterable={true}
                      onFilterChange={this.filterPractices}
                  />
              </div>
            )}
          </div>
          

          <div className="row">

            {this.state.pmUserRole && (
              <div className="col-md-3">
                  <label className="">Project Region:</label>
                  <MultiSelect  
                      data={this.state.projectRegions}
                      name="selectedProjectRegion"
                      textField="Name"
                      placeholder={'Please Select'}
                      onChange={this.handleInputChange}
                      value={this.state.selectedProjectRegion}
                      filterable={true}
                      onFilterChange={this.filterProjectRegions}
                  />
              </div>
            )}

            {this.state.pmUserRole && (
              <div className="col-md-3">
                  <label className="">Customer:</label>
                  <MultiSelect  
                      data={this.state.customers}
                      name="selectedCustomer"
                      textField="Name"
                      placeholder={'Please Select'}
                      onChange={this.handleInputChange}
                      value={this.state.selectedCustomer}
                      filterable={true}
                      onFilterChange={this.filterCustomers}
                  />
              </div>
            )}

            {this.state.pmUserRole && (
              <div className="col-md-3">
                  <label className="">Designation:</label>
                  <MultiSelect  
                      data={this.state.designations}
                      name="selectedDesignation"
                      textField="Name"
                      placeholder={'Please Select'}
                      onChange={this.handleInputChange}
                      value={this.state.selectedDesignation}
                      filterable={true}
                      onFilterChange={this.filterDesignations}
                  />
              </div>
            )}

            {this.state.pmUserRole && (
              <div className="col-md-3">
                  <label className="">Skill Area:</label>
                  <MultiSelect  
                      data={this.state.skillAreas}
                      name="selectedSkillArea"
                      textField="name"
                      placeholder={'Please Select'}
                      onChange={this.handleInputChange}
                      value={this.state.selectedSkillArea}
                      filterable={true}
                      onFilterChange={this.filterSkillArea}
                  />
              </div>
            )}

            <div className="col-md-3">
                <div className="d-block">
                  <label htmlFor="">Month: </label>
                </div>
                <div className="d-block">
                    <div className="title-remove">
                        <DatePicker
                            format={'MM/yyyy'}
                            calendar={CustomCalendar}
                            width="100"
                            name="startDate"
                            onChange={this.handleStartDateChange}
                            value={this.state.startDate}
                            formatPlaceholder={{ year: 'YYYY', month: 'MM'}}
                        />
                    </div>
              </div>
            </div>

            {this.state.pmUserRole && (
              <div className="col-md-3">
                <div className="d-block mt-2">
                  <label htmlFor=""></label>
                </div>
                <input
                  type="radio"
                  name="selectedduration"
                  value="resduration"
                  className="k-radio"
                  id="resduration"
                  onChange={this.handleDurationChange}
                  checked={!this.state.isApprovedDuration}
                />
                <label className="k-radio-label mr-3" htmlFor="resduration">
                    Resource Entered Duration
                </label>

                <input
                  type="radio"
                  name="selectedduration"
                  value="approvedduration"
                  className="k-radio"
                  id="approvedduration"
                  onChange={this.handleDurationChange}
                  checked={this.state.isApprovedDuration}
                />
                <label className="k-radio-label" htmlFor="approvedduration">
                    Approved Duration
                </label>
              </div>
            )}
          </div>

          <div className="row"></div>

          <div className="row">
            <div className="col-md-12 btn-align-right">
              <Button primary={true} type="submit" onClick={this.submitSearch}>
                Search
              </Button>
              <Button type="button" onClick={this.cancelSearch}>
                Clear
              </Button>
            </div>
          </div>

        </form>

        <div className="main-seperator" />

        <div className="row">
          <div className="col-md-6">
            <div className="main-heading">Search Results</div>
          </div>
        </div>

        {/* Color Legends */}
        <div className="row">
          <div className="col-md-12">
            <div className="daily-uitilization-legend-container">
              <div className="daily-uitilization-legend-item">
                <div className="daily-uitilization-legend-box" style={{ backgroundColor: '#bab7b6' }}></div>
                <label>Weekend</label>
              </div>
              <div className="daily-uitilization-legend-item">
                <div className="daily-uitilization-legend-box" style={{ backgroundColor: '#b1e0fc' }}></div>
                <label>Holiday/Leave</label>
              </div>
              <div className="daily-uitilization-legend-item">
                <div className="daily-uitilization-legend-box" style={{ backgroundColor: '#f7f4c3' }}></div>
                <label>No Project Allocation</label>
              </div>
            </div>
          </div>
        </div>

        <div className="row window-ta fade-in">
            <div className="col-md-12 panel-dark">
                {this.state.resourceList && this.state.resourceList.length === 0 &&
                    <div className="no-record-wrap"> No records available </div>
                }
                {this.state.resourceList && this.state.resourceList.length !== 0 &&
                    this.state.resourceList.map(resource => (

                    <PanelBar
                      className="mt-2"
                      key={resource.id}
                      onSelect={e => {
                        this.getAllocationList(resource.id);
                      }}
                    >
                      <PanelBarItem
                        expanded={false}
                        animation={true}
                        title={
                          <div className="font-weight-bold">
                              <label htmlFor="reso-name" className="reso-name">
                                  Resource : {resource.Name}{' '}
                              </label>
                          </div>
                        }
                      >
                      <div className="py-3 daily-uitilization-grid">
                          <Grid
                            data={this.state.allocationList[resource.id]}
                            style={this.state.allocationList[resource.id] && this.state.allocationList[resource.id].length > 10 ? { height: '450px' } : ''}
                          >
                             <GridColumn 
                              field="" 
                              width="45px" 
                              title=""
                              locked={true} 
                              cell={props => (
                                props.dataItem.EditAccess ? 
                                <td style={{ position: 'sticky', left: 0, backgroundColor: '#fff', zIndex: 1 }}>
                                  <a href="#" onClick={event => this.onClickEditAllocation(event, props.dataItem)}>
                                    <div className="rounded-link">
                                      <span className="k-icon k-i-edit" title="Allocation (%) Change" />
                                    </div>
                                  </a>
                                </td> : 
                                <td style={{ position: 'sticky', left: 0, backgroundColor: '#fff', zIndex: 1 }}></td>
                              )}
                              footerCell={() => {
                                return <td style={{ position: 'sticky', left: 0, backgroundColor: '#fff', zIndex: 1 }}>
                                    <div>{}</div>
                                    <div>{}</div>
                                  </td>;
                              }}
                            />  
                            <GridColumn 
                              field="ProjectName" 
                              width="140px" 
                              title="Project" 
                              locked={true} 
                              footerCell={() => {
                                return <td style={{ position: 'sticky', left: '45px', backgroundColor: '#fff', zIndex: 1 }}>        
                                    <div style={{ marginBottom: '10px' }}>Billable Total</div>
                                    <div>Non-Billable Total</div>
                                </td>;
                              }}
                            />
                            <GridColumn 
                              field="AllocationType" 
                              width="100px" 
                              title="Allocation Type"
                              locked={true} 
                              footerCell={() => {
                                return <td style={{ position: 'sticky', left: '185px', backgroundColor: '#fff', zIndex: 1 }}>
                                    <div>{}</div>
                                    <div>{}</div>
                                  </td>;
                              }}
                            />
                            <GridColumn title={'Monthly Utilization'} locked={true}>
                              <GridColumn 
                                field="ActualUtilizationTotal" 
                                width="65px" 
                                title="Actual"
                                locked={true} 
                                className="summary-grid-bold-style"
                                cell={(props) => (
                                  <td style={{ position: 'sticky', left: '285px', backgroundColor: '#778DA9', zIndex: 1, fontWeight: 'bold' }}>
                                    {props.dataItem[props.field]}
                                  </td>
                                )}                              
                                footerCell={() => {
                                  return <td style={{ position: 'sticky', left: '285px', backgroundColor: '#778DA9', zIndex: 1 }}>
                                      <div style={{ marginBottom: '15px' }}>{this.setMonthlyTotal(resource.id, 'totalBillActualUtilization')}</div>
                                      <div>{this.setMonthlyTotal(resource.id, 'totalNonBillActualUtilization')}</div>
                                    </td>;
                                }}
                              />  
                              <GridColumn 
                                field="PlannedUtilizationTotal" 
                                width="65px" 
                                title="Planned"
                                locked={true} 
                                className="summary-grid-bold-style"
                                cell={(props) => (
                                  <td style={{ position: 'sticky', left: '350px', backgroundColor: '#778DA9', zIndex: 1, fontWeight: 'bold'}}>
                                    {props.dataItem[props.field]}
                                  </td>
                                )}           
                                footerCell={() => {
                                  return <td style={{ position: 'sticky', left: '350px', backgroundColor: '#778DA9', zIndex: 1 }}>
                                      <div style={{ marginBottom: '15px' }}>{this.setMonthlyTotal(resource.id, 'totalBillPlannedUtilization')}</div>
                                      <div>{this.setMonthlyTotal(resource.id, 'totalNonBillPlannedUtilization')}</div>
                                    </td>;
                                }}
                              />  
                            </GridColumn>

                            {this.state.dateColumnsArray.map(date => (
                                <GridColumn title={`${date}`}>
                                    <GridColumn
                                        field={''}
                                        title={'Actual'}
                                        width="65px"
                                        cell={props => this.customCell(props, date, 'Actual')}
                                        footerCell={() =>               
                                          <td>
                                            <div>{this.setDailyTotal(resource.id, date, 'Actual', 'Billable')}</div>
                                            <div>{this.setDailyTotal(resource.id, date, 'Actual', 'NonBillable')}</div>
                                          </td>
                                        }
                                    />
                                    <GridColumn
                                        field={''}
                                        title={'Planned'}
                                        width="65px"
                                        cell={props => this.customCell(props, date, 'Planned')}
                                        footerCell={() =>               
                                          <td>
                                            <div>{this.setDailyTotal(resource.id, date, 'Planned', 'Billable')}</div>
                                            <div>{this.setDailyTotal(resource.id, date, 'Planned', 'NonBillable')}</div>
                                          </td>
                                        }
                                    />
                                </GridColumn>
                            ))}                   
                          </Grid>
                      </div>
                      </PanelBarItem>
                    </PanelBar>
                ))}
          </div>
        </div>

        <Loader loading={this.state.loading} />

        {this.state.showChangeAllocationDialog === true && (
          <Dialog title="Allocation Percentage Change" onClose={this.toggleDialogAllocationPercentage} width="400px">
            <div className="d-flex flex-col justify-content-start" style={{margin: '15px'}}>
              <div className="d-block  col-md-4">
                <label>Allocation (%):</label>
              </div>

              <div className="d-block">
                <div>
                  <DebounceInput
                    debounceTimeout={2000}
                    width="100"
                    onChange={this.handleAllocationPercentageChange}
                    value={this.state.changedllocationPercentage}
                    name="changedllocationPercentage"
                    type="number"
                    className="k-textbox"
                    required={true}
                  />
                </div>
              </div>
            </div>

            <div className="d-flex flex-col justify-content-start" style={{margin: '15px'}}>
              <div className="d-block  col-md-4">
                <label>Start Date:</label>
              </div>

              <div className="d-block">
                <div>
                  <DatePicker
                    width="100"
                    name="allocationPercentageStartDate"
                    value={this.state.allocationPercentageStartDate}
                    min={this.state.allocationHistoryMinDate}
                    max={this.state.allocationPercentageEndDate ? this.state.allocationPercentageEndDate : this.state.allocationHistoryMaxDate}
                    format="MM/dd/yyyy"
                    formatPlaceholder={{year: 'YYYY', month: 'MM', day: 'DD'}}
                    onChange={this.handleAllocationStartDateChange}
                    popup={CustomDatePickerPopUp}
                  />
                </div>
              </div>
            </div>

            <div className="d-flex flex-col justify-content-start" style={{margin: '15px'}}>
              <div className="d-block col-md-4">
                  <label>End Date:</label>
                </div>

                <div className="d-block">
                  <div>
                    <DatePicker
                      width="100"
                      name="allocationPercentageEndDate"
                      value={this.state.allocationPercentageEndDate}
                      min={this.state.allocationPercentageStartDate ? this.state.allocationPercentageStartDate : this.state.allocationHistoryMinDate}
                      max={this.state.allocationHistoryMaxDate}
                      format="MM/dd/yyyy"
                      formatPlaceholder={{year: 'YYYY', month: 'MM', day: 'DD'}}
                      onChange={this.handleAllocationEndDateChange}
                      popup={CustomDatePickerPopUp}
                    />
                  </div>
                </div>
              </div>

              <div className="d-flex flex-col justify-content-start" style={{margin: '15px'}}>
                <div className="d-block col-md-4">
                  <label>Effort Days:</label>
                </div>

                <div className="d-block">
                  <div>
                    <DebounceInput
                      width="100"
                      name="allocationPercentageEndDate"
                      value={this.state.allocationPercentageEffortDays}
                      disabled={true}
                      className="k-textbox"
                    />
                  </div>
                </div>
              </div>

            <DialogActionsBar>
              <button className="k-button" onClick={this.toggleDialogAllocationPercentage}>
                Cancel
              </button>

              <button className="k-button modal-primary" disabled={this.state.disableConfirmButton} onClick={this.updateAllocationPercentageHistory}>
                Confirm
              </button>
            </DialogActionsBar>
          </Dialog>
        )}

        {this.state.showMessageDialog === true && (
          <Dialog title={this.state.dialogTitle} onClose={this.toggleMessageDialog} width="400px">

            {this.state.showSuccessImage === true && (
              <div className="text-center">
                <img className="successImg" src={SuccessImg} alt="Success"/>
              </div>
            )}

            {this.state.showErrorImage === true && (
              <div className="text-center">
                <img className="successImg" src={ErrorImg} alt="Error Image"/>
              </div>
            )}

            <p style={{ margin: '25px', textAlign: 'center' }}>{this.state.dialogMessage}</p>
            <DialogActionsBar>
              {this.state.showErrorImage === true && (
                <button className="k-button modal-primary" onClick={this.toggleMessageDialog}>
                  OK
                </button>
              )}
            </DialogActionsBar>
          </Dialog>
        )}
      </div>
    );
  }
}

export default DailyUtilization;



